import { Plan } from '@wix/ambassador-pricing-plans-v3-plan/types';

export function orderPlansForMobileView(plans: Plan[], highlightedId: string): Plan[] {
  const highlightedIndex = plans.findIndex((plan) => plan.id === highlightedId);
  if (highlightedIndex > 0) {
    const highlightedPlan = plans[highlightedIndex];
    return [highlightedPlan, ...plans.filter((plan) => plan !== highlightedPlan)];
  }

  return plans;
}
